export default __webpack_public_path__ + "static/media/gray-color-alarm.4cb99ae0.svg";